import { render, staticRenderFns } from "./RundownItemCommand.vue?vue&type=template&id=428e538a&"
import script from "./RundownItemCommand.vue?vue&type=script&lang=js&"
export * from "./RundownItemCommand.vue?vue&type=script&lang=js&"
import style0 from "./RundownItemCommand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports